import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function useLocalizeDocumentAttributes() {
  const { t, i18n } = useTranslation();
  const componentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (i18n.resolvedLanguage && componentRef.current) {
      // Set the <div> or component root element dir attribute.
      componentRef.current.dir = i18n.dir(i18n.resolvedLanguage);
    }

    // 👇 Localize document title.
    document.title = t('app_title');
  }, [i18n, i18n.resolvedLanguage, t]);
  return componentRef;
}
